"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterHelpExamples = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var copy_1 = require("../../../../../copy");
var MeterHelp_styled_1 = require("./MeterHelp.styled");
var MeterHelpExamples = function () {
    var Heading4 = (0, core_1.useComponents)().Heading4;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(MeterHelp_styled_1.StyledExamples, null,
        react_1.default.createElement("section", null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleOneHeading" })),
            react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(MeterHelp_styled_1.StyledExampleOne, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleOneInfo" })))),
        react_1.default.createElement("section", null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleTwoHeading" })),
            react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(MeterHelp_styled_1.StyledExampleTwo, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleTwoInfo" })))),
        react_1.default.createElement("section", null,
            react_1.default.createElement(Heading4, null,
                react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleThreeHeading" })),
            react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(MeterHelp_styled_1.StyledExampleThree, null)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpExampleThreeInfo" }))))));
};
exports.MeterHelpExamples = MeterHelpExamples;
